var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow right",
    clipPath: "url(#clip0_2673_22286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57689 2.98959L0.954139 0.357836C0.801444 0.214126 0.567909 0.214126 0.424189 0.357836C0.280479 0.501546 0.280479 0.744066 0.424189 0.887786L2.78649 3.25009L0.424189 5.6124C0.280479 5.7651 0.280479 5.9986 0.424189 6.14235C0.567899 6.28605 0.801434 6.28605 0.954139 6.14235L3.57689 3.51959C3.7206 3.36689 3.7206 3.13331 3.57689 2.98959Z",
    fill: "#F86557"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2673_22286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrow right.26173b35e12a519a2fa52dd3fb9996b9.svg";
export { ForwardRef as ReactComponent };